module.exports = __webpack_public_path__ + "img/thundercore.ce8e0f7f.svg";